import { FormGroup, ValidationErrors } from '@angular/forms';

// custom validator to check that two fields match
export function MatchEmailValidator(emailControlName: string, confirmEmailControlName: string, shouldValidate: boolean | (() => boolean)) {
    return (formGroup: FormGroup) => {
        const emailControl = formGroup.get(emailControlName);
        const confirmEmailControl = formGroup.get(confirmEmailControlName);

        // Determine if validation should occur
        const validate = typeof shouldValidate === 'function' ? shouldValidate() : shouldValidate;

        // Only validate if needed
        if (!validate) {
            return null;
        }

        if (emailControl.value !== confirmEmailControl.value) {
            confirmEmailControl.setErrors({ emailMismatch: true });
            return { emailMismatch: true };
        }

        confirmEmailControl.setErrors(null);
        return null;
    };
}

export const emailRegex = new RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/);
